module.exports = __webpack_public_path__ + "assets/d3112459b1fdafd43b9242e3921cf744.png";